require('./base.js');

require('../../../public/javascripts/postcards/postcard.js')
require('expose?Remarkable!../../../public/javascripts/mdeditor/remarkable.min.js')
require('expose?MDConvert!exports?MDConvert!../../../public/javascripts/mdconvert.js')
require('../../../public/javascripts/ambassadors/show.js')



// WEBPACK FOOTER //
// ./app/assets/javascripts/ambassadors-show.js